import { showTawkWidget } from '~~/libs/helper/tawk'

// TODO: enable live chat
export default defineNuxtRouteMiddleware(async (to, from) => {
  return

  if (process.server)
    return

  const TawkMessenger = await import('@tawk.to/tawk-messenger-vue-3')
  const nuxt = useNuxtApp()

  if (!nuxt.vueApp.config.globalProperties.$tawkInstalled) {
    nuxt.vueApp.config.globalProperties.$tawkInstalled = true

    nuxt.vueApp.use(TawkMessenger.default, {
      propertyId: '64228dfc31ebfa0fe7f50f40',
      widgetId: '1gsjfl9am',
    })
  }

  if (to.meta.liveChat === false)
    return showTawkWidget(false)

  showTawkWidget(true)
})
